// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"52177c46","97":"0d7ed9ec","725":"52177c46"}[chunkId] + ".css";
};